<template>
    <div>

        <p class="title is-5">Cashback settings</p>
        <p class="title help is-6">
            To fully setting the bonus, configure in the 
            <router-link :to="{ name: 'branch-list' }" target="_blank">client settings</router-link>
             -> branch -> Bonuses settings -> Cashback
            <span class="has-text-danger">(client setting == branch setting)</span>
        </p>

        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Enabled</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <label class="checkbox">
                            <input v-model="bonus.enabled" type="checkbox" />
                        </label>
                    </p>
                </div>
            </div>
        </div>

        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Percent</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="bonus.percent" class="input oc-input" type="number" />
                    </p>
                </div>
            </div>
        </div>

        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Period</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <div class="select">
                            <select v-model="bonus.period">
                                <option value="1.00:00:00">Daily</option>
                                <option value="7.00:00:00">Weekly</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Date time of first payment</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input ref="start" class="input oc-input" type="text" readonly />
                    </p>
                </div>
            </div>
        </div>

        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Date time of next payment</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <span class="oc-form-text">{{bonus.next | datetime(true)}}</span>
                    </p>
                </div>
            </div>
        </div>

        <p class="title is-5">Notification</p>

        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Enabled</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <label class="checkbox">
                            <input v-model="bonus.notificationEnabled" type="checkbox" />
                        </label>
                    </p>
                </div>
            </div>
        </div>

        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Default messenger</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <div class="select">
                            <select v-model="bonus.notificationMessenger">
                                <option value="sms">Sms</option>
                                <option value="tg">Telegram</option>
                                <option value="vb">Viber</option>
                                <option value="wa">WhatsApp</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="field is-horizontal">
            <div class="field-label"></div>
            <div class="field-body">
                <div class="field is-grouped">
                    <div class="control">
                        <button @click="save" class="button is-primary">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import state from '../../../../../state';
import dt from '../../../../../services/datetime.service';
import clientService from '../../../../../services/client.service';
import utils from '../../../../../utils';

import flatpickr from 'flatpickr';

export default {
    name: 'client-settings-cashback-bonus',
    data() {
        return {
            client: null,
            bonus: {},
            calendar: null
        };
    },
    computed: {
        clientId() {
            return Number(this.$route.params.clientId);
        }
    },
    watch: {
        clientId() {
            this.load();
        }
    },
    async mounted() {
        await clientService.ensure();
        this.load();

        let date = dt.local(this.bonus.start).format('YYYY-MM-DD HH:mm');
        this.calendar = flatpickr(this.$refs.start, {
            enableTime: true,
            time_24hr: true,
            defaultDate: date
        });
    },
    methods: {
        load() {
            this.client = utils.clone(state.clients.getClient(this.clientId));
            this.bonus = this.client.settings.bonusSettings.cashback;
        },
        async save() {
            const start = dt.fixDate(this.calendar.selectedDates[0]);
            this.bonus.start = dt
                .local(start)
                .utc()
                .toISOString();
            this.client.settings.bonusSettings.cashback = this.bonus;
            await clientService.save(this.client);
        }
    }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/settings/bonuses/cashback.vue